/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Load_ErrorInputs */

const en_notifications_load_error = /** @type {(inputs: Notifications_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load notifications.`)
};

const pl_notifications_load_error = /** @type {(inputs: Notifications_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się wczytać powiadomień.`)
};

/**
* | output |
* | --- |
* | "Could not load notifications." |
*
* @param {Notifications_Load_ErrorInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const notifications_load_error = /** @type {((inputs?: Notifications_Load_ErrorInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Load_ErrorInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_notifications_load_error(inputs)
	return en_notifications_load_error(inputs)
});